/**
 * KAN-1003: каркас публичных страниц (соглашение, политика, цены): без
 * сайдбара кабинета, открыт без входа, внизу юридический подвал.
 */
import { useEffect, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_NAME } from '@/content/legal/support';
import { LegalFooter } from './LegalFooter';

interface LegalPageShellProps {
  /** Текст вкладки браузера. */
  documentTitle: string;
  children: ReactNode;
}

export function LegalPageShell({ documentTitle, children }: LegalPageShellProps) {
  useEffect(() => {
    document.title = `${documentTitle} - ${SERVICE_NAME}`;
  }, [documentTitle]);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col px-4 py-6 sm:px-6 sm:py-10">
        <div className="mb-6">
          <Link to="/" className="text-xl font-bold text-blue-600">
            {SERVICE_NAME}
          </Link>
        </div>
        <main className="flex-1 rounded-lg bg-white p-4 shadow sm:p-8">{children}</main>
        <LegalFooter className="mt-8" />
      </div>
    </div>
  );
}
